import { Directive, EventEmitter, HostBinding, HostListener, inject, Output } from '@angular/core';

@Directive({
  selector: '[queDrag]',
  standalone: true
})
export class DragDirective {

  @Output() FilesEvent: EventEmitter<FileList> = new EventEmitter()
  
  @HostBinding("style.background") private background = "#ffffff"

  @HostListener("dragover", ["$event"])
  public onDargOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = "#3e61dd0f"
  }

  @HostListener("dragleave", ["$event"])
  public onDargLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = "#fffff"
  }

  @HostListener("drop", ["$event"])
  public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = "white";
    if (evt.dataTransfer) {
      const files = evt.dataTransfer.files;
      // const url = this.#sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file))
      // var fileHndle = { file, url } as FileHandle
      this.FilesEvent.emit(files)
    }
  }
}
